import { createI18n } from 'vue-i18n' //引入vue-i18n组件
import zh from './locales/zh.json'
import en from './locales/en.json'
import enLocale from 'element-plus/lib/locale/lang/en'
import zhLocale from 'element-plus/lib/locale/lang/zh-cn'

import vxeZH from 'vxe-table/lib/locale/lang/zh-CN'
import vxeUS from 'vxe-table/lib/locale/lang/en-US'

import pinia from '@/store'

import { useAppStore } from '@/store/modules/app'
import { getUrlKey } from '@/utils'
import { storeToRefs } from 'pinia'

export { enLocale, zhLocale }
const messages = {
  'en-US': {
    ...en,
    ...vxeUS,
  },
  'zh-CN': {
    ...zh,
    ...vxeZH,
  },
}
function getLanguage() {
  const { event } = storeToRefs(useAppStore())
  //console.log('Version', event.value)
  return event.value.Version
}

const i18n = createI18n({
  fallbackLocale: 'zh-CN',
  globalInjection: true,
  legacy: false,
  locale: 'zh-CN',
  messages,
})

export default i18n
